$(function(){
		//クリックで動く
		$('.nav-open').click(function(){
          console.log("fire")
			$(this).toggleClass('active');
			$(this).next('.ac-nav').slideToggle();
		});
	});

$('#trace-cart-button').on('click', function() {
 console.log("fire")
        $(".add-to-cart input").trigger('click');
    });

$(document).on('click', '#c-sw', function(){
 var fire = $(this).data('li')
  $(this).parents(".product-list-item").find("img").attr('src',fire);
  $(this).parents(".product-list-item").find("img").attr('srcset',fire);
    });

// $(document).on('click', '.product-thumbnails .thumbnail', function(){
//   var mediaType = $(this).data('media-type');
//   var mediaUrl = $(this).data('media-url');

//   if (mediaType === 'image') {
//     $(".product-big-image").html('<img src="' + mediaUrl + '" class="product-list-item-image" />');
//   } else if (mediaType === 'video') {
//     var videoElement = $('<video controls class="product-big-video"><source src="' + mediaUrl + '" type="video/mp4">Your browser does not support the video tag.</video>');
//     $(".product-big-image").html(videoElement);
//     videoElement[0].load();
//     videoElement[0].addEventListener('loadeddata', function() {
//       videoElement[0].play();
//     });
//   }
// });

$('#bb-btn').on('click', function() {
 console.log("fire")
  $(".in_fixed_bottom").addClass("ab-hide");
    $("#tidio-chat-iframe").addClass("stop")
    });